export const stringsKey = "MessageScheduleRow";
export const englishStrings = {
	previewMessageSegmentToolTip: "Preview Message Segment",
	approximateMessageCostToolTip: "Approximate Message Cost",
	makeRecurringToolTip: "Make Recurring",
	recurringWhen: "Recurring",
	viewRecurringSchedule: "View Recurring Schedule",
	recurringDailyOption: "Daily",
	recurringWeeklyOption: "Weekly",
	recurringMonthlyOption: "Monthly",
	weeklyRecurringErrorNoDays:
		"At least one day must be selected for a monthly recurrence",
	monthlyRecurringErrorBeforeMonth:
		"Please select a date in the current month or in the future.",
};
